import React from 'react';
import styled from 'styled-components';
import * as AppActions from '../../../AppActions';

function CreatorItem(props) {
  const {creator} = props;
  return (
    <Wrapper onClick={() => AppActions.navigate(`/creator/${creator.path}`)}>
      <img alt="creator-img" src={creator.image} />
      <h3>{creator.name}</h3>
      <p>{creator.description}</p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  cursor: pointer;
  width: 300px;

  & > img {
    margin-bottom: 20px;
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  & > h3 {
    margin-bottom: 20px;
    min-height: 50px;
  }

  & > p {
    white-space: pre-wrap;
    color: #aeb6b8;
  }

  @media screen and (max-width: 1200px) {
    width: 250px;

    & > img {
      height: 250px;
    }
  }

  @media screen and (max-width: 500px) {
    width: 200px;

    & > img {
      height: 200px;
    }
  }
`;

export default CreatorItem;
